import React, { useState, useEffect, useRef } from "react";

const ABOUT_API = "https://backenddev.aaerlaw.com/api/user/paraclearth_about_us";

function stripHtml(html) {
  if (!html) return "";
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
}

function AboutSection() {
  const [lightbox, setLightbox] = useState(null);
  const [current, setCurrent] = useState(0);
  const [isAuto, setIsAuto] = useState(true);
  const timerRef = useRef(null);
  const TOTAL = 5;
  const [aboutData, setAboutData] = useState(null);

  const slides = [
    { leftTop: "assets/img/eze_gabriel_full.jpeg", leftBottom: "assets/img/about_us_square.jpeg", right: "assets/img/bg-img/4.jpg" },
    { leftTop: "assets/img/bg-img/4.jpg",          leftBottom: "assets/img/eze_gabriel_full.jpeg", right: "assets/img/about_us_square.jpeg" },
    { leftTop: "assets/img/about_us_square.jpeg",  leftBottom: "assets/img/bg-img/4.jpg", right: "assets/img/eze_gabriel_full.jpeg" },
    { leftTop: "assets/img/bg-img/3.jpg",          leftBottom: "assets/img/eze_gabriel_full.jpeg", right: "assets/img/about_us_square.jpeg" },
    { leftTop: "assets/img/eze_gabriel_full.jpeg", leftBottom: "assets/img/bg-img/3.jpg", right: "assets/img/bg-img/4.jpg" },
  ];

  const stopAuto = () => {
    setIsAuto(false);
    clearInterval(timerRef.current);
  };

  const prev = () => { stopAuto(); setCurrent((c) => (c - 1 + TOTAL) % TOTAL); };
  const next = () => { stopAuto(); setCurrent((c) => (c + 1) % TOTAL); };

  useEffect(() => {
    if (!isAuto) return;
    timerRef.current = setInterval(() => setCurrent((c) => (c + 1) % TOTAL), 3500);
    return () => clearInterval(timerRef.current);
  }, [isAuto]);

  useEffect(() => {
    fetch(ABOUT_API)
      .then((r) => r.json())
      .then((json) => setAboutData(json))
      .catch(() => {});
  }, []);

  const { leftTop, leftBottom, right } = slides[current];

  return (
    <div id="about">
      {/* Lightbox Overlay */}
      {lightbox && (
        <div
          onClick={() => setLightbox(null)}
          style={{
            position: "fixed", inset: 0, zIndex: 9999,
            backgroundColor: "rgba(0,0,0,0.92)",
            display: "flex", alignItems: "center", justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <img
            src={lightbox}
            alt=""
            style={{ maxHeight: "90vh", maxWidth: "90vw", objectFit: "contain" }}
            onClick={(e) => e.stopPropagation()}
          />
          <button
            onClick={() => setLightbox(null)}
            style={{
              position: "absolute", top: "1rem", right: "1.25rem",
              background: "none", border: "none", color: "#fff",
              fontSize: "2rem", lineHeight: 1, cursor: "pointer",
            }}
            aria-label="Close"
          >&times;</button>
        </div>
      )}

      <section className="about-section bg-secondary">
        <div className="divider"></div>

        <div className="container-fluid container-lg px-0 px-lg-3">
          <div className="row g-3 g-lg-5 align-items-center">
            {/* About Thumbnail */}
            <div className="col-12 col-lg-6">
              <div className="about-thumbnail px-0">
                <div className="row g-2 g-md-4 align-items-end">
                  <div className="col-6">
                    <div className="about-img-wrap" style={{ position: "relative", display: "inline-block", width: "100%" }}>
                      <img
                        src="assets/img/eze_gabriel_full.jpeg"
                        alt=""
                        className="wow fadeInUp w-100"
                        data-wow-duration="1000ms"
                        data-wow-delay="600ms"
                        style={{ cursor: "pointer", display: "block" }}
                        onClick={() => setLightbox("assets/img/eze_gabriel_full.jpeg")}
                      />
                      <span
                        onClick={() => setLightbox("assets/img/eze_gabriel_full.jpeg")}
                        style={{ position: "absolute", bottom: "8px", right: "8px", background: "rgba(0,0,0,0.2)", color: "#fff", borderRadius: "4px", padding: "4px 6px", cursor: "pointer", lineHeight: 1, opacity: 0.8 }}
                      ><i className="ti ti-arrows-maximize"></i></span>
                    </div>
                    {/* Second Image */}
                    <div className="about-img-wrap mt-2 mt-md-4" style={{ position: "relative", display: "inline-block", width: "100%" }}>
                      <img
                        src="assets/img/managing_partner_2.jpeg"
                        alt=""
                        className="wow fadeInUp w-100 about-partner-image about-partner-image-one"
                        data-wow-duration="1000ms"
                        data-wow-delay="800ms"
                        style={{ cursor: "pointer", display: "block" }}
                        onClick={() => setLightbox("assets/img/managing_partner_2.jpeg")}
                      />
                      <span
                        onClick={() => setLightbox("assets/img/managing_partner_2.jpeg")}
                        style={{ position: "absolute", bottom: "8px", right: "8px", background: "rgba(0,0,0,0.2)", color: "#fff", borderRadius: "4px", padding: "4px 6px", cursor: "pointer", lineHeight: 1, opacity: 0.8 }}
                      ><i className="ti ti-arrows-maximize"></i></span>
                    </div>
                  </div>
                  <div className="col-6">
                    {/* Third Image */}
                    <div className="about-img-wrap" style={{ position: "relative", display: "inline-block", width: "100%" }}>
                      <img
                        src="assets/img/managing_partner_1.jpeg"
                        alt=""
                        className="wow fadeInUp w-100 about-partner-image about-partner-image-two"
                        data-wow-duration="1000ms"
                        data-wow-delay="1000ms"
                        style={{ cursor: "pointer", display: "block" }}
                        onClick={() => setLightbox("assets/img/managing_partner_1.jpeg")}
                      />
                      <span
                        onClick={() => setLightbox("assets/img/managing_partner_1.jpeg")}
                        style={{ position: "absolute", bottom: "8px", right: "8px", background: "rgba(0,0,0,0.2)", color: "#fff", borderRadius: "4px", padding: "4px 6px", cursor: "pointer", lineHeight: 1, opacity: 0.8 }}
                      ><i className="ti ti-arrows-maximize"></i></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* About Content */}
            <div className="col-12 col-lg-6">
              <div className="about-content ps-md-4">
                <div className="section-heading">
                  <div className="sub-title">
                    <img src="assets/img/core-img/hammer.png" alt="" />
                    About Us
                  </div>
                  <h2 className="mb-4">Paraclete and Earth Increase LP (Paraclearth)</h2>
                  {aboutData?.about_us && (
                    <p className="mb-4">{stripHtml(aboutData.about_us)}</p>
                  )}
                  {aboutData?.vision && (
                    <div className="mb-3">
                      <p className="fw-semibold text-heading mb-1">Vision</p>
                      <p className="mb-0">{stripHtml(aboutData.vision)}</p>
                    </div>
                  )}
                  {aboutData?.mission && (
                    <div className="mb-4">
                      <p className="fw-semibold text-heading mb-1">Mission</p>
                      <p className="mb-0">{stripHtml(aboutData.mission)}</p>
                    </div>
                  )}
                  <p className="fw-semibold text-heading mb-4">
                    "As our clients innovate and expand, we stand ready to support them with precision, creativity, and the highest standard of professional excellence."
                  </p>

                  {/* Manager Info */}
                  <div className="manager-info d-flex align-items-center gap-3">
                    <div className="manager-thumbnail">
                      <img src="assets/img/eze.gabriel.jpeg" alt="" />
                    </div>
                    <div>
                      <p className="mb-0">Eze C. Gabriel</p>
                      <p className="mb-0">Co-founding Partner</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="divider"></div>
      </section>
    </div>
  );
}

export default AboutSection;
